import { groupBy, trim } from "lodash";

export const addBrInStr = (str, len = 4) => {
  const result = [];
  for (let index = 0; index < str.length; index++) {
    const ele = str[index];
    result.push(ele);
    if (index % len === len - 1) {
      result.push('\n');
    }
  }
  return result.join('');
}

/**
 * 字符串解析称数组
 * @param {string} str 
 * @returns {Array}
 */
export const parseStringToArray = (str) => {
  if (typeof str !== 'string') return null;
  // 解析称一个矩阵数据
  return str.split('\n')
    .filter(item => item.trim() !== '')
    .map(ele => ele.split('\t'));
}

/**
 * 将excel复制出来的字符串转成二维数组
 * @param {string} str 
 * @param {
 *  handleColumn: Function;
 *  defaultKey: string;
 * } param1 
 * @returns {}
 */
export const parseArrayToTable = (rows, {
  handleColumn,
  defaultKey,
}) => {
  const KEY_PREFIX = defaultKey || 'key_';
  const columns = [];
  const list = [];

  rows.forEach((ele, index) => {
    // 第一行为标题
    if (index === 0) {
      ele.forEach((name, innerIndex) => {
        columns.push({
          dataIndex: `${KEY_PREFIX}${innerIndex}`,
          title: name,
          ...(handleColumn && handleColumn(name, innerIndex)),
        });
      })
    } else {
      const record = ele.reduce((acc, curr, currIndex) => {
        return {
          ...acc,
          [`${KEY_PREFIX}${currIndex}`]: curr,
        };
      }, {});
      list.push(record);
    }
  })

  return {
    columns,
    list,
  };
}


/**
 * 将excel复制出来的字符串转成二维数组
 * @param {string} str 
 * @param {
*  handleColumn: Function;
*  defaultKey: string;
* } param1 
* @returns {}
*/
export const parseArrayToChart = (rows, {
  handleColumn,
  defaultKey,
}) => {
  const KEY_PREFIX = defaultKey || 'key_';
  const columns = [];
  const list = [];

  rows.forEach((ele, index) => {
    // 第一行为标题
    if (index === 0) {
      ele.forEach((name, innerIndex) => {
        columns.push({
          dataIndex: `${KEY_PREFIX}${innerIndex}`,
          name,
          list: [],
          ...(handleColumn && handleColumn(name, innerIndex)),
        });
      })
    } else {
      ele.forEach((item, currIndex) => {
        if (currIndex > 0) {
          columns[currIndex - 1].list.push(item);
        }else{
          list.push(item);
        }
      });
    }
  })

  return {
    columns,
    list,
  };
}

/**
 * 复杂表头解析
 * @param {*} dataset 
 * @returns 
 */
export const parseArrayToComplexTable = (dataset) => {
  const group = groupBy(dataset, (val) => {
    return val[0]
  })

  const list = []
  const columns = Object.keys(group).map((item, groupIndex) => {
    const groupItem = group[item];
    const children = [];
    groupItem.forEach(([_parentName, title, ...values], index) => {
      const dataIndex = `key_${groupIndex}_${index}`;

      // 矩阵转成对象
      values.forEach((val, i) => {
        if (!list[i]) {
          list[i] = {};
        }
        list[i][dataIndex] = val;
      })
      // 表头
      children.push({ title, dataIndex })
    });

    return {
      title: item,
      children,
    }
  })

  return {
    columns,
    list,
  };
}


export const groupDataset = (dataset = [], deep) => {
  const res = new Map();

  dataset.forEach(([name, ...arr]) => {
    let list = res.get(name);
    if (!list) {
      list = []
      res.set(name, list)
    }
    list.push(arr)
  });

  if (deep > 1) {
    res.forEach((val, key) => {
      const value = groupDataset(val, deep - 1);
      // console.log('=====)))))0000', val, value);
      res.set(key, value);
    })
  }

  return res;
}


export const parseMapToArray = (mapList) => {
  const result = [];

  mapList.forEach((value, name) => {
    let _value = value;
    if (value instanceof Map) {
      _value = parseMapToArray(value);
    }
    result.push({
      name,
      value: _value,
    })
  })

  return result;
}

/**
 * 图表中用的千分符
 * @param {Number | String} num 
 */
export const toVisualThousands = (num) => {
  const reg = /\d{1,3}(?=(\d{3})+$)/g;
  if (!num) return 0;
  return (`${parseInt(num)}`).replace(reg, '$&,');
}

/**
 * 编辑文案中的千分符
 * @param {Number | String} num 
 */
export const formatThousands =(event) =>{
  if (event.target.innerText) {
     event.target.innerText = event.target.innerText
      .replace(/(\d),(\d)/g, "$1$2")
      .replace(/(\d)(?=(\d{3}\D?)+(\D|$))/g, "$1,");
       
  }
}

/**
 * 向上取整
 * @param {*} number 
 * @returns 
 */
export const ceilNumber = (number) => {
  let bite = 0;
  if(number < 10){
    return 10;
  }
  while( number >= 10 ){
    number /= 10;
    bite += 1;
  }
  return Math.ceil(number) * Math.pow(10,bite);
}

export const applyThousands = (list) => {
  return list.map(item => {
    const result = {};
    for (const key in item) {
      if (Object.hasOwnProperty.call(item, key)) {
        const element = trim(item[key]);
        result[key] = /^\d+$/.test(element) ? toVisualThousands(element) : element
      }
    }
    return result;
  })
}




// WEBPACK FOOTER //
// src/routes/visualChart/utils.js